import { gql } from "@apollo/client";

const QUERY_SCHEDULES = gql`
  query GetSchedulesByProductId($productId: ID!) {
    getSchedulesByProductId(productId: $productId) {
      _id
      acknowledgement {
        acknowledgementType
        address {
          address1
          address2
          city
          country
          state
          zip
        }
        customAcknowledgement
        name
        use
        ldsUse {
          mrn
          ward
          stake
          tithing
          fastOffering
          generalMissionaryFund
          wardMissionaryFund
          humanitarianAid
          other
          notes
        }
      }
      expedite
      endDate
      executedOccurrences
      frequency
      nextExecutionDate
      dueNow
      scheduledOccurrences
      startDate
      status
      cancellationReason
      cancellationDate
      meta {
        testData
      }
      transactionAmount
      complianceReview {
        lane
        reasonCode
        feeAmount
      }
      recipientCollection
      recipient {
        ... on OrganizationEntity {
          _id
          ein
          charityType
          entityName
          address {
            city
            country
            state
          }
          increase {
            achTransfers
            wireTransfers
          }
        }
      }
    }
  }
`;

export { QUERY_SCHEDULES };
